import React from 'react';
import { Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import './ImageLinks.css';

import { getMediaUrl } from '../../../utils/request';

interface ImageLink {
  id: string;
  title: string;
  image: string;
  url: string;
  description?: string;
}

interface ImageLinksProps {
  links?: ImageLink[];
}

const defaultLinks: ImageLink[] = [
  {
    id: '1',
    title: '就聊天',
    image: 'https://micahbj.com/upload/aiimg/lt.png',
    url: '#',
    description: '与AI助手对话咨询',
  },
  {
    id: '2',
    title: '自己画',
    image: 'https://micahbj.com/upload/aiimg/ht.png',
    url: 'https://micahbj.com/huxingtu/',
    description: '使用AI工具自主设计',
  },
  {
    id: '3',
    title: '找人画',
    image: 'https://micahbj.com/upload/aiimg/sjs.png',
    url: '#',
    description: '寻找专业设计师服务',
  },
];

const ImageLinks: React.FC<ImageLinksProps> = ({ links = defaultLinks }) => {
  const navigate = useNavigate();

  const getFullImageUrl = (url: string) => {
    if (url.startsWith('http')) return url;
    return getMediaUrl(url);
  };

  const scrollToTop = () => {
    const wrapper = document.querySelector('.chat-content-wrapper');
    if (wrapper) wrapper.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleClick = (link: ImageLink) => {
    // 点击图片链接后回到页面顶部
    scrollToTop();

    // 如果设置了有效的链接，进行页面跳转
    if (link.url && link.url !== '#') {
      // 判断是外部链接还是内部路由
      if (link.url.startsWith('http://') || link.url.startsWith('https://')) {
        // 外部链接：在新标签页打开
        window.open(link.url, '_blank', 'noopener,noreferrer');
      } else if (link.url.startsWith('/')) {
        // 内部路由：使用 React Router 导航
        navigate(link.url);
      } else {
        // 其他情况：直接跳转
        window.location.href = link.url;
      }
      return;
    }

    // 如果没有设置链接或链接为 '#'，执行特殊处理逻辑
    if (link.id === '1') {
      // 就聊天 - 回到顶部，再聚焦输入框；聚焦后可能触发浏览器滚到底部，故稍后再滚回顶部
      scrollToTop();
      requestAnimationFrame(() => {
        window.dispatchEvent(new CustomEvent('focusInput'));
        setTimeout(scrollToTop, 150);
      });
    } else if (link.id === '2') {
      // 自己画 - 可以后续扩展功能
      console.log('自己画功能待开发');
    } else if (link.id === '3') {
      // 找人画 - 可以后续扩展功能
      console.log('找人画功能待开发');
    }
  };

  return (
    <div className="image-links-container">
      {links.map((link) => (
        <Card
          key={link.id}
          className="image-link-card"
          hoverable
          cover={
            <div className="image-link-cover">
              <img alt={link.title} src={getFullImageUrl(link.image)} />
            </div>
          }
          onClick={() => handleClick(link)}
        >
          <Card.Meta title={link.title} description={link.description} />
        </Card>
      ))}
    </div>
  );
};

export default ImageLinks;
